import { render } from "./FilterBrand.vue?vue&type=template&id=aefe8602"
import script from "./FilterBrand.vue?vue&type=script&lang=js"
export * from "./FilterBrand.vue?vue&type=script&lang=js"
script.render = render

export default script